import { TriggerType } from "@/types/alert";

export const TRIGGER_TYPE: TriggerType = {
  hit_rate: {
    label: "hit rate",
    comparison: "is less than",
  },
  memory_usage: {
    label: "memory usage",
    comparison: "is greater than",
  },
};

// The max number of alerts that can be created on the highest MemCachier plan.
// For Analytics only. Eventually will probably make sense to be sent from the backend.
export const ALERT_MAX = 100;
